<template>
  <div class="prepareLessons">
    <div class="clearfix top">
      <div class="fl">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="所属">
            <el-select v-model="form.resource" clearable @change="search">
              <el-option label="全部" value=""></el-option>
              <el-option label="平台" value="1"></el-option>
              <el-option label="校区" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="类型">
            <el-select
              v-model="oj_problem_list_type_id"
              filterable
              placeholder="请选择"
              clearable
              @change="search"
            >
              <el-option
                v-for="item in ojProblemListTypeList1"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题单名称">
            <el-input
              v-model="keyword"
              prefix-icon="el-icon-search"
              placeholder="请输入题单名称"
              size="mini"
              clearable
              @keyup.enter.native="getSchoolOjProblemlistList"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="fl">
        <el-button
          type="primary"
          @click="search"
          icon="el-icon-search"
          size="mini"
          >查询</el-button
        >

        <!-- <el-button type="primary" icon="el-icon-plus" @click="add1" size="mini">新增题单</el-button> -->
      </div>

      <div
        class="fr"
        v-if="$store.state.user.identity === 2 ? false : true"
        @click="myNew"
        style="cursor: pointer;"
      >
        <span
          style="float:right; font-size:15px;margin-left:5px;font-weight:bold;line-height: 20px;"
          >我创建的题单</span
        >

        <svg
          style="float:right;"
          t="1658478152829"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="13892"
          width="20"
          height="20"
        >
          <path
            d="M588.2 59.3H265.9c-66.6 0-120.7 54-120.7 120.7v661.9c0 66.6 54 120.7 120.7 120.7h492.3c66.6 0 120.7-54 120.7-120.7v-495c0-32.4-13-63.4-36.1-86.1l-170-166.9c-22.7-22.2-53-34.6-84.6-34.6z"
            fill="#39AFDA"
            p-id="13893"
          ></path>
          <path
            d="M186.5 219c0-66.6 54-120.7 120.7-120.7h322.2c25 0 49.1 7.8 69.3 22l-35.1-34.4a120.47 120.47 0 0 0-75.4-26.5H265.9c-66.6 0-120.7 54-120.7 120.7V842c0 20.5 5.1 39.7 14.1 56.6 9.5 4.7 19.8 8 30.5 10.1-2.1-8.9-3.3-18.2-3.3-27.7V219z"
            fill="#9CE4F3"
            p-id="13894"
          ></path>
          <path
            d="M704.7 911c66.6 0 120.7-54 120.7-120.7v-495c0-32.4-13-63.4-36.1-86.1l-90.5-88.9c-20.2-14.2-44.3-22-69.3-22H307.2c-66.6 0-120.7 54-120.7 120.7v661.9c0 9.6 1.2 18.8 3.3 27.7 7.3 1.4 14.8 2.3 22.6 2.3h492.3z"
            fill="#52C5F8"
            p-id="13895"
          ></path>
          <path
            d="M355.4 392.9h-90.6c-0.9 0-1.7-0.8-1.7-1.7v-90.6c0-0.9 0.8-1.7 1.7-1.7h90.6c0.9 0 1.7 0.8 1.7 1.7v90.6c-0.1 1-0.8 1.7-1.7 1.7z"
            fill="#FC8308"
            p-id="13896"
          ></path>
          <path
            d="M726.5 373.4H407.3c-1.5 0-2.7-1.2-2.7-2.7v-49.5c0-1.5 1.2-2.7 2.7-2.7h319.1c1.5 0 2.7 1.2 2.7 2.7v49.5c0.1 1.5-1.1 2.7-2.6 2.7z"
            fill="#FFFFFF"
            p-id="13897"
          ></path>
          <path
            d="M355.4 570.2h-90.6c-0.9 0-1.7-0.8-1.7-1.7v-90.6c0-0.9 0.8-1.7 1.7-1.7h90.6c0.9 0 1.7 0.8 1.7 1.7v90.6c-0.1 0.9-0.8 1.7-1.7 1.7z"
            fill="#FECE0A"
            p-id="13898"
          ></path>
          <path
            d="M726.5 550.7H407.3c-1.5 0-2.7-1.2-2.7-2.7v-49.5c0-1.5 1.2-2.7 2.7-2.7h319.1c1.5 0 2.7 1.2 2.7 2.7V548c0.1 1.5-1.1 2.7-2.6 2.7z"
            fill="#FFFFFF"
            p-id="13899"
          ></path>
          <path
            d="M355.4 732.8h-90.6c-0.9 0-1.7-0.8-1.7-1.7v-90.6c0-0.9 0.8-1.7 1.7-1.7h90.6c0.9 0 1.7 0.8 1.7 1.7v90.6c-0.1 0.9-0.8 1.7-1.7 1.7z"
            fill="#F24500"
            p-id="13900"
          ></path>
          <path
            d="M726.5 713.3H407.3c-1.5 0-2.7-1.2-2.7-2.7V661c0-1.5 1.2-2.7 2.7-2.7h319.1c1.5 0 2.7 1.2 2.7 2.7v49.5c0.1 1.6-1.1 2.8-2.6 2.8zM314.9 544.8l-11 11c-0.3 0.3-0.9 0.3-1.2 0l-38.2-38.2c-0.3-0.3-0.3-0.9 0-1.2l11-11c0.3-0.3 0.9-0.3 1.2 0l38.2 38.2c0.4 0.3 0.4 0.9 0 1.2z"
            fill="#FFFFFF"
            p-id="13901"
          ></path>
          <path
            d="M302.1 556l-11-11c-0.3-0.3-0.3-0.9 0-1.2l53.3-53.3c0.3-0.3 0.9-0.3 1.2 0l11 11c0.3 0.3 0.3 0.9 0 1.2L303.3 556c-0.4 0.3-0.9 0.3-1.2 0z"
            fill="#FFFFFF"
            p-id="13902"
          ></path>
        </svg>
      </div>
    </div>
    <div class="mian">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ color: '#909399' }"
      >
        <el-table-column type="index" label="序号"> </el-table-column>

        <el-table-column prop="" label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.oj_problem_list_type_id === null">--</span>
            <span v-else>
              <span>{{ scope.row.totalInfo.title }}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" label="题单名称">
          <template slot-scope="scope">
            <span class="txtTable" @click="goNext(scope.row)">{{
              scope.row.title
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="problem_num"
          align="center"
          label="题目数"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="usedCount"
          align="center"
          label="使用次数"
          width="100"
        >
        </el-table-column>

        <el-table-column prop="problem_num" label="完成度" width="200">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.num"></el-progress>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination
          @current-change="handleCurrent"
          :current-page="page_no"
          :page-size="page_size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSchoolOjProblemlistList,
  ojTchGetOjProblemListTypeListWithOutP,
} from '@/api/educational.js'
export default {
  data() {
    return {
      addForm: {},
      dialogVisible: false,
      keyword: '',
      ojProblemListTypeList1: [],
      oj_problem_list_type_id: '',
      page_no: 1,
      page_size: 20,
      total: 20,
      form: {
        resource: '',
      },
      activeClass: 0,
      topList: [],
      tableData: [{}],
    }
  },
  mounted() {
    this.getSchoolOjProblemlistList()
    this.ojTchGetOjProblemListTypeListWithOutlist()
  },
  methods: {
    ojTchGetOjProblemListTypeListWithOutlist() {
      ojTchGetOjProblemListTypeListWithOutP({}).then((res) => {
        console.log(res)
        this.ojProblemListTypeList1 = res.ojProblemListTypeList
      })
    },
    search() {
      this.page_no = 1
      this.getSchoolOjProblemlistList()
    },
    setItemProgress(data) {
      if (data.problemAcceptNum > data.problem_num) {
        return 100
      } else {
        return parseInt(
          (data.problemAcceptNum / data.problem_num).toFixed(1) * 100
        )
      }
    },
    setItemText(data) {
      return () => {
        return +data.problemAcceptNum + ' / ' + data.problem_num
      }
    },
    getSchoolOjProblemlistList() {
      getSchoolOjProblemlistList({
        title_code: this.keyword,
        oj_problem_list_type_id: this.oj_problem_list_type_id,
        isPlatform: this.form.resource,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res)
        this.tableData = res.ojProblemList
        this.total = res.total
        this.tableData.map((item) => {
          if (item.problem_num === 0) {
            item.num = 0
          } else {
            item.num = parseInt(
              (item.problemAcceptNum / item.problem_num).toFixed(2) * 100
            )
          }
        })
        console.log(this.tableData, 4512212)
      })
    },
    goDetaisl() {
      this.$router.push({
        name: 'ListOfUestionsList',
        query: {},
      })
    },
    add1() {
      this.dialogVisible = true
    },
    handleCurrent(val) {
      this.page_no = val
      this.getSchoolOjProblemlistList()
    },
    goNext(row) {
      sessionStorage.setItem('Ojtd', row.title)

      console.log('题单信息')
      console.log(row)

      this.$router.push({
        name: 'ListOfUestionsList',
        query: {
          description: row.description,
          problemlist_id: row.id,
          practice: 'practice',
          title: row.title,
          code: row.code,
          problemAcceptNum: row.problemAcceptNum,
          problem_num: row.problem_num,
          educational: row.educational_institution_id,
        },
      })
    },
    myNew() {
      this.$router.push({
        name: 'MyListOfUestions',
        query: {},
      })
    },
  },
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
<style scoped lang="scss">
.prepareLessons {
  margin: 10px;
  min-height: calc(100vh - 120px);
  //   background: #ccc;
  border-radius: 5px;
  overflow: hidden;
}

.top {
  padding: 20px;
  padding-bottom: 0px;
  font-size: 18px;
  font-weight: 300;
  background: #fff;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

/deep/ .el-dropdown-link {
  cursor: pointer;
  color: #333;
}

.line {
  height: 50px;
  width: 2px;
  background: #999;
  margin: 0 20px;
}

.top li {
  cursor: pointer;
  float: left;
  margin-right: 20px;
}

.active {
  color: #41b146;
}

.topFrom ::v-deep .el-form-item {
  margin-bottom: 0px;
}

.mian {
  margin-top: 10px;
  padding: 10px 10px 10px 10px;

  background: #fff;
  box-sizing: border-box;
}

.txtTable {
  cursor: pointer;
}

.txtTable:hover {
  color: #2e95fb;
}
</style>
